// extracted by mini-css-extract-plugin
export default {"skipdatecontain":"gU","skip_info":"hU","skipped":"iU","modify_order":"jU","cancel_subscription_btn":"kU","byb":"lU","modify_order_outer":"mU","byb_edit_btn":"nU","modify_order_item":"oU","cancel_copy_wrapper":"pU","cancelled_copy":"qU"};
    if(module.hot) {
      // 1711394579683
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  